import { createPortal } from "react-dom";

export default function CookieConsentBanner({
  onAcceptAll,
  onRejectAll,
  onOpenPreferences,
}) {
  // Portaled straight to <body> — an ancestor (the mode-switch page-enter
  // animation wrapper) applies a CSS transform, which turns it into a
  // containing block for any position:fixed descendant. Rendering here
  // instead of in-tree keeps this pinned to the viewport regardless of what
  // animates further up the tree.
  return createPortal(
    <div
      className="cookie-banner"
      role="region"
      aria-label="Cookie hozzájárulás"
    >
      <div className="cookie-banner-inner">
        <p className="cookie-banner-text">
          Sütiket használunk a működéshez, névtelen statisztikákhoz és
          hirdetéseinkhez. Részletek az{" "}
          <a href="/adatkezelesi-tajekoztato">adatkezelési tájékoztatóban</a>.
        </p>

        <div className="cookie-banner-actions">
          <button
            type="button"
            className="cookie-banner-btn cookie-banner-btn-reject"
            onClick={onRejectAll}
          >
            Elutasítom
          </button>
          <button
            type="button"
            className="cookie-banner-btn-link"
            onClick={onOpenPreferences}
          >
            Beállítások
          </button>
          <button
            type="button"
            className="cookie-banner-btn cookie-banner-btn-accept"
            onClick={onAcceptAll}
          >
            Elfogadom mindet
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
